import * as React from 'react';
import { Route } from 'react-router';
import { ToastContainer } from 'react-toastify';

import Layout from './components/layout/Layout';
import Home from './components/Home';

export default () => (
  <>
    <ToastContainer autoClose={3000} position='top-center' />
    <Layout>
      <Route exact path='/' component={Home} />
    </Layout>
  </>
);
